import MultiSelect from "../../components/MultiSelect";
import i18next from "i18next";
import * as categoriesServices from "../../services/gendersServices";
import { useEffect, useState } from "react";
import useDebouncedFunction from "../../hooks/useDebouncedFunction";
import Autocomplete from "../../components/Autocomplete";

interface CategoriesSelectProps {
	value?: any;
	showValue?: any;
	onChange?: any;
	error?: any;
	multiple?: boolean;
	required?: boolean;
}

const CategorySelect = ({ multiple, value, showValue, onChange, error, required }: CategoriesSelectProps) => {
	const [categories, setCategories] = useState<any>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (!showValue) {
			handleChangeSearch({ target: { value: "" } });
		}
	}, [showValue]);

	const handleChangeSearch = async (e: any) => {
		const value = e?.target?.value;

		setLoading(true);
		var categories = await categoriesServices.categoriesSearch({ skip: 0, limit: 10, search: value });
		categories = categories.result.map((category) => ({
			label: category.name,
			value: category,
			...category,
		}));
		setCategories(categories);
		setLoading(false);
	};

	const debouncedSearch = useDebouncedFunction(handleChangeSearch);

	if (multiple)
		return (
			<MultiSelect
				options={categories.filter((g) => !value?.map((g) => g.id)?.includes(g.id))}
				placeholder={i18next.t("entity-search", { entity: i18next.t("Category") })}
				datatestid={"search-category-input"}
				label={i18next.t("categories")}
				value={value}
				onInputChange={(e) => {
					setLoading(true);
					debouncedSearch(e);
				}}
				renderValue={(value) => <div>{value.map(({ name }) => name).join(", ")}</div>}
				showValue={showValue}
				onChange={onChange}
				error={error}
				loading={loading}
				required={required}
			/>
		);

	return (
		<Autocomplete
			options={categories}
			placeholder={i18next.t("entity-search", { entity: i18next.t("Category") })}
			datatestid={"search-category-input"}
			label={i18next.t("categories")}
			value={value}
			onInputChange={(e) => {
				setLoading(true);
				debouncedSearch(e);
			}}
			showValue={showValue}
			onChange={onChange}
			error={error}
			loading={loading}
			required={required}
		/>
	);
};

export default CategorySelect;
